import React from 'react'
import PropTypes from 'prop-types'
import { DateInput } from 'ra-ui-materialui'
import { dataFormatter, dataParser } from '../../services/date'

const DateInputProps = (FieldComponent) =>
  FieldComponent === DateInput
    ? {
        parse: dataParser,
        format: dataFormatter,
      }
    : {}

const StyledInput = (props) => {
  const { component: FieldComponent } = props
  return (
    <FieldComponent
      InputLabelProps={{
        shrink: true,
      }}
      variant="outlined"
      fullWidth
      {...DateInputProps(FieldComponent)}
      {...props}
    />
  )
}

StyledInput.defaultProps = {
  component: React.Fragment,
}

StyledInput.propTypes = {
  component: PropTypes.func,
}

export default StyledInput
